import { styled, css, Box, BoxProps } from '@mui/material'
import Counter from '../Counter'
import Button from '../Button'
import Text from '../Text'
import { MainFooterStylesProps } from './MainFooter.types'
import Price from '../Price'

export const MainFooterWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['fullWidth'].includes(String(prop))
})<BoxProps & MainFooterStylesProps>(
  () => css`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    padding: 0;
  `
)

export const CounterButtonWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['fullWidth'].includes(String(prop))
})<BoxProps & MainFooterStylesProps>(
  ({ fullWidth, isCounterOnTop }) => css`
    display: flex;
    align-items: stretch;
    justify-content: center;
    min-height: 48px;
    padding: 8px;
    gap: 8px;

    flex-direction: ${isCounterOnTop ? 'column' : 'row'};

    ${fullWidth &&
    css`
      padding: 0;
      gap: 0;

      .Counter,
      .MainButton {
        border-radius: 0;
      }
    `}
  `
)

export const ResumeWrapper = styled(Box)(
  () => css`
    width: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  `
)

export const ResumeTitle = styled(Text)(
  () => css`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
  `
)

export const ResumeValue = styled(Price)(
  ({ theme }) => css`
    font-size: 16px;
    font-weight: 700;
    color: ${theme.palette.primary.main};
  `
)

export const ResumeCounterWrapper = styled(Box)(
  () => css`
    display: flex;
    justify-content: space-between;
  `
)

export const FooterCounterWrapper = styled(Counter)(
  () => css`
    padding: 8px;
  `
)

export const MainFooterButton = styled(Button, {
  shouldForwardProp: (prop) => !['actions'].includes(String(prop))
})(
  () => css`
    flex-grow: 1;
  `
)
MainFooterButton.defaultProps = {
  size: 'large',
  fullWidth: true
}

MainFooterWrapper.defaultProps = {
  fullWidth: true
}

export const MainFooterText = styled(Text)(
  ({ theme }) => css`
    color: ${theme.palette.primary.main};
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.3px;
    text-decoration-line: underline;
    cursor: pointer;
    text-align: center;
  `
)
